module.exports = __webpack_public_path__ + "static/media/magnetSecond.e18d5215.PNG";